import * as api from '../api';

const FEEDBACK = '/feedback';

export const getFeedbackOptionFromServer = (projectId) => api.get(`${FEEDBACK}/project/${projectId}`);

export const sendFeedbackOptionToServer = (data) => api.post(FEEDBACK, data);
